import CSVPreviewSection from '../CSVPreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function EstimateVsActualCSVPreviewGroupingSection() {}

EstimateVsActualCSVPreviewGroupingSection.prototype = new CSVPreviewSection();

EstimateVsActualCSVPreviewGroupingSection.prototype.init = function(groupingLevelsArray, columnsConfig, reportAuthorizationInfo){
    CSVPreviewSection.prototype.init.call( this );
    
    this.groupingLevelsArray = groupingLevelsArray;
    this.columnsConfig = columnsConfig;
    this.reportAuthorizationInfo = reportAuthorizationInfo
    
    this.numOfDataColumns = 4 + this.columnsConfig.getNumOfDataColumns(); // total spent, est time, variance mh, variance %
    this.numOfGroupingRows = this.groupingLevelsArray.length;
    
    return this;
};

EstimateVsActualCSVPreviewGroupingSection.prototype.isGroupinRowWithEstimates = function ( groupingLevel ) {
    return (groupingLevel !== ReportGroupingLevel.USER)
};

EstimateVsActualCSVPreviewGroupingSection.prototype._addGroupCell = function(row, groupingLevel, secondRowOfLastLevel) {

    if (groupingLevel === ReportGroupingLevel.USER) {
        const allUsersAvailable = this.reportAuthorizationInfo.allUsersAvailable
        const anyOtherUsersAvailable = this.reportAuthorizationInfo.anyOtherUsersAvailable
        const needSwitchToMe = !allUsersAvailable && !anyOtherUsersAvailable
        const needToShowOthers = !allUsersAvailable

        if (secondRowOfLastLevel) {
            if (!needSwitchToMe && !needToShowOthers) {
                this.addCell(row, this.message("report.user"))
            } else {
                this.addCell(row, this.message("report.common.others"))
            }
        } else if (needSwitchToMe) {
            this.addCell(row, this.message("report.common.me"))
        } else {
            this.addCell(row, this.message("report.common.user"))
        }
    } else {
        this.addCell(row,  ReportPreviewUtils.getLevelPreviewName(groupingLevel))
    }
}

EstimateVsActualCSVPreviewGroupingSection.prototype.addRows = function ( tBody )
{
    for (let i = 0; i < this.numOfGroupingRows + 1; i++) {
        let secondRowOfLastLevel = i >= this.numOfGroupingRows
        let groupingLevelNumber = secondRowOfLastLevel ? this.numOfGroupingRows - 1 : i
        const groupingLevel = this.groupingLevelsArray[groupingLevelNumber]
        const row = this.createRow()

        for (let j = 0; j < this.numOfGroupingRows; ++j) {
            if (i === j || secondRowOfLastLevel && j === groupingLevelNumber) {
                this._addGroupCell(row, groupingLevel, secondRowOfLastLevel)
            } else {
                ReportPreviewUtils.addEmptyCell(row);
            }
        }

        this.addValueCell( row, ReportPreviewUtils.getCSVTimeValue() ); // total time spent

        this.columnsConfig.addCellValues(row, groupingLevel); // total time spent

        if ( this.isGroupinRowWithEstimates(groupingLevel) ) {
            this.addValueCell( row, ReportPreviewUtils.getCSVTimeValue() ); // estimate time
            this.addValueCell( row, this.getCSVShortTimeValue() ); // variance mh
            this.addValueCell( row, this.getCSVPercentValue() ); // variance %
        } else {
            ReportPreviewUtils.addEmptyCell(row);
            ReportPreviewUtils.addEmptyCell(row);
            ReportPreviewUtils.addEmptyCell(row);
        }
        
        
        this.addRow( tBody, row );
    }

    const emptyRow = this.createRow()
    const totalColumnsNum = this.numOfGroupingRows + this.numOfDataColumns

    for (let i = 0; i < totalColumnsNum; i++)
        ReportPreviewUtils.addEmptyCell( emptyRow );
    
    this.addRow( tBody, emptyRow );

    const totalRow = this.createRow()
    this.addCell( totalRow, this.message("report.budgeted_vs_actual.total") );
    for (let i = 1; i < this.numOfGroupingRows; i++)
        ReportPreviewUtils.addEmptyCell( totalRow );

    this.addValueCell( totalRow, ReportPreviewUtils.getCSVTimeValue() ); // total time spent
    this.columnsConfig.addCellValues( totalRow, null );  // total time spent for...

    this.addValueCell( totalRow, ReportPreviewUtils.getCSVTimeValue() ); // estimate time
    this.addValueCell( totalRow, this.getCSVShortTimeValue() ); // variance mh
    this.addValueCell( totalRow, this.getCSVPercentValue() ); // variance %
    
    this.addRow( tBody, totalRow );
};

EstimateVsActualCSVPreviewGroupingSection.prototype.getCSVShortTimeValue = function()
{
    return "1" + SystemSettings.decimalSeparator + "23";
};

EstimateVsActualCSVPreviewGroupingSection.prototype.getCSVPercentValue = function()
{
    return "1" + SystemSettings.decimalSeparator + "23%";
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/eva/EstimateVsActualCSVPreviewGroupingSection.js